import { render, staticRenderFns } from "./UploadStl.vue?vue&type=template&id=160814b4"
import script from "./UploadStl.vue?vue&type=script&lang=js"
export * from "./UploadStl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports